<template>
<div style="background:#fcfcfd">
<div class="container">
    <div style="padding-top:20px"><span style="cursor:pointer" @click="gotoHome()">HOME</span> - CONTACT</div>
    <div class="row" style="padding:30px 0px;padding-top:15px">
        <div class="col-md-3">
            <left></left>
        </div>
        <div class="col-md-9" style="color:#333;font-size:15px;line-height:25px;">
             <p style="text-align:center;margin-bottom:30px">
                <img src="/static/images/contact.jpg" style="width:100%;box-shadow:0px 0px 10px #aaa"/>
            </p>
            <ul>
                <li><strong>{{$t('contact_1')}}</strong> <br>
                    <div class="row">
                        <div class="col-md-6">{{$t('contact_email')}} cliff@adachemicals.com</div> <div class="col-md-6">{{$t('contact_tel')}} 0086-13917648345</div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">{{$t('contact_mobile')}}13917648345</div> <div class="col-md-6"></div>
                    </div>
                </li><br>
                <li><strong>{{$t('contact_2')}}</strong> <br>
                    <div class="row">
                        <div class="col-md-12">{{ $t('contact_addr_1') }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">{{$t('contact_tel')}} 0086-533-7525879</div> <div class="col-md-6">{{$t('contact_fax')}} 0086-533-7484168</div>
                    </div>
                </li>
                <br>
                <li><strong>{{$t('contact_3')}}</strong> <br>
                    <div class="row">
                        <div class="col-md-12">{{ $t('contact_addr_2') }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">{{$t('contact_tel')}} 0086-21-58569507</div> <div class="col-md-6"> {{$t('contact_fax')}} 0086-21-58201568</div>
                    </div>
                </li>
                                
                </ul>
                
                <div style="padding:20px;margin-top:20px;">
                <contact></contact>
                </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
import left from './left';
import contact from './contact';
export default {
    created(){
    
    },
    mounted(){
        
    },
    components: {
        left,
        contact
    },
    data(){
        return{
           
        }
    },
    methods:{
        gotoHome(){
            this.$router.push('/');
        },
    }
};
</script>

<style>
.navbar-brand-img{
    width: 150px;
    height:auto;
}
</style>



// WEBPACK FOOTER //
// contactus.vue?e8eea950